/* Manic Fits — collection page: live filters and sort, load more, mobile filter panel. */
const SEL = '[data-mcol]';

const sectionOf = (el) => el && el.closest(SEL);

/* Fetch a collection URL rendered as just this section, then swap it in place. */
async function swap(sec, url, push = true) {
  const id = sec.dataset.sectionId;
  const u = new URL(url, location.origin);
  const fetchUrl = new URL(u);
  fetchUrl.searchParams.set('section_id', id);
  sec.setAttribute('aria-busy', 'true');
  try {
    const res = await fetch(fetchUrl.toString(), { credentials: 'same-origin' });
    if (!res.ok) throw new Error(String(res.status));
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const fresh = doc.querySelector(SEL);
    if (!fresh) throw new Error('no section');
    const wasOpen = sec.querySelector('[data-mcol-panel]')?.open;
    sec.replaceWith(fresh);
    const panel = fresh.querySelector('[data-mcol-panel]');
    if (panel && isMobile()) panel.open = !!wasOpen;
    if (push) history.pushState({ mcol: true }, '', u.pathname + u.search);
  } catch (err) {
    location.href = u.toString();
  } finally {
    sec.removeAttribute('aria-busy');
  }
}

const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

function formUrl(form) {
  const data = new FormData(form);
  const params = new URLSearchParams();
  for (const [k, v] of data) if (v !== '') params.append(k, v);
  return `${form.action}?${params.toString()}`;
}

let timer;
document.addEventListener('change', (e) => {
  const form = e.target.closest('[data-mcol-form]');
  const sort = e.target.closest('[data-mcol-sort]');
  if (sort) {
    const sec = sectionOf(sort);
    const f = sec.querySelector('[data-mcol-form]');
    f.querySelector('[data-mcol-sort-input]').value = sort.value;
    swap(sec, formUrl(f));
    return;
  }
  if (!form) return;
  clearTimeout(timer);
  const delay = e.target.type === 'number' ? 600 : 0;
  timer = setTimeout(() => swap(sectionOf(form), formUrl(form)), delay);
});

document.addEventListener('submit', (e) => {
  const form = e.target.closest('[data-mcol-form]');
  if (!form) return;
  e.preventDefault();
  swap(sectionOf(form), formUrl(form));
});

document.addEventListener('click', async (e) => {
  const link = e.target.closest('[data-mcol-link]');
  if (link && !e.metaKey && !e.ctrlKey) {
    e.preventDefault();
    swap(sectionOf(link), link.href);
    return;
  }
  const more = e.target.closest('[data-mcol-more]');
  if (!more || e.metaKey || e.ctrlKey) return;
  e.preventDefault();
  const sec = sectionOf(more);
  const grid = sec.querySelector('[data-mcol-grid]');
  more.setAttribute('aria-busy', 'true');
  more.textContent = 'Loading…';
  try {
    const u = new URL(more.href, location.origin);
    u.searchParams.set('section_id', sec.dataset.sectionId);
    const res = await fetch(u.toString(), { credentials: 'same-origin' });
    if (!res.ok) throw new Error(String(res.status));
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    doc.querySelectorAll('[data-mcol-item]').forEach((it) => grid.appendChild(it));
    const nextWrap = doc.querySelector('[data-mcol-more-wrap]');
    const curWrap = sec.querySelector('[data-mcol-more-wrap]');
    if (nextWrap && curWrap) curWrap.replaceWith(nextWrap);
    const shown = doc.querySelector('[data-mcol-shown]');
    const curShown = sec.querySelector('[data-mcol-shown]');
    if (shown && curShown) curShown.textContent = shown.textContent;
  } catch (err) {
    location.href = more.href;
  }
});

window.addEventListener('popstate', () => {
  const sec = document.querySelector(SEL);
  if (sec) swap(sec, location.href, false);
});

/* Mobile: start with the filter panel closed; JS users don't need the Apply button. */
function init() {
  document.documentElement.classList.add('mcol-js');
  if (isMobile()) document.querySelectorAll('[data-mcol-panel]').forEach((p) => (p.open = false));
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
